import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSearchParams } from 'react-router-dom';
import LoginModal from 'components/LoginModal';
import DemoModal from 'components/DemoModal';
import '../../styles/TailRiskGlobal.css';

export default function Login() {
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next') || '/dashboard';
  const [demoOpen, setDemoOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>Sign In — Tail Risk Global</title>
        <meta name="description" content="Sign in to your Tail Risk Global client portal." />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Barlow:wght@300;400;500;600&family=Barlow+Condensed:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>

      {/* Dark background so the overlay has something to sit on */}
      <div className="trg-page" style={{ minHeight: '100vh' }} />

      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />

      {/* Always-open modal: no × button, "Back to home" shown in footer */}
      <LoginModal
        open={true}
        onClose={null}
        onRequestDemo={() => setDemoOpen(true)}
        next={next}
      />
    </>
  );
}
